module.exports = __webpack_public_path__ + "img/4.569d69d1.jpg";